import React from 'react';
import { ReloadContainerNavItem } from '../../../../../../../components/ReloadContainerNavItem';

type Props = {
  loading: boolean;
  refetch: () => void;
};

export const ReloadButton: React.FC<Props> = ({ loading, refetch }) => (
  <ReloadContainerNavItem loading={loading} descriptor="charge point" onClick={refetch} />
);
